/**
 * OVERRIDE Anontools.jsx
 */

import Anontools from '../../../../components/Anontools/Anontools';

export default Anontools;